<template>
  <SettingsPagePanel
    v-if="
      autoChatReplySetting.extra.type ===
        AutoChatReplySettingExtraType.Question &&
      autoChatReplySetting.extra.question
    "
  >
    <p :class="$style.title">選択肢に自動応答する設定</p>
    <ul :class="$style.list">
      <li
        v-for="selection in autoChatReplySetting.extra.question.selections"
        :key="selection.text"
        :class="$style.listItem"
      >
        <span v-if="selection.link">
          <!--
              RouterLink を使っていない

              AutoChatReplySettingDetailPage から AutoChatReplySettingDetailPage への遷移なので、RouterView である AutoChatReplySettingDetailPage が再描画されない
              そのため a 要素を使って、Vue Router による遷移ではなく、ブラウザによる遷移を行う

              別の対応として RouterView に :key="$route.path" を指定する方法もあるが、それはできない
              理由： その場合 カルテ一覧 -> カルテ詳細（ペイン表示） -> カルテ一覧に遷移したとき、カルテ一覧が再読み込みされてしまい、ユーザー体験が悪い
            -->
          <span>
            <a
              :href="
                router.resolve({
                  name: 'autoChatReplySettingDetail',
                  params: {
                    entranceGUID: route.params.entranceGUID,
                    autoChatReplySettingId: selection.link.id,
                  },
                }).href
              "
            >
              {{ selection.text }}
            </a>
          </span>
        </span>
        <span v-else>
          <span>{{ selection.text }}</span>
          <span> - </span>
          <a
            :href="
              router.resolve({
                name: 'autoChatReplySettingNew',
                query: { keyword: selection.text },
              }).href
            "
          >
            このキーワードで条件を作成する
          </a>
        </span>
      </li>
    </ul>
  </SettingsPagePanel>
</template>

<script setup lang="ts">
import { type SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragment } from './SettingsPageAutoChatReplyKeywordLinkSectionPanel.generated'
import { AutoChatReplySettingExtraType } from '@/types/schema.generated'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import { useRoute, useRouter } from 'vue-router'

defineProps<{
  autoChatReplySetting: SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragment
}>()

const router = useRouter()
const route = useRoute('autoChatReplySettingDetail')
</script>

<style module lang="scss">
.title {
  font-weight: bold;
  margin-bottom: 16px;
}

.list {
  margin-left: 16px;
  list-style-type: circle;
}

.listItem {
  padding: 8px 0;
}
</style>
